var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"competency-label",class:[_vm.competencyBorderColorClass, _vm.competencyTextColorClass]},[_c('Tooltip',{attrs:{"content":_vm.competencyTypeTooltip,"max-width":"300","placement":_vm.placement}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }